module.exports = __webpack_public_path__ + "static/media/doulanshan_mobile.57186105.png";